export default __webpack_public_path__ + "static/media/support-rapidminer.5ee14802.yaml";